import { SvgIcon } from "@mui/material";

export const PromoIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 16 16">
      <path
        d="M2.65926 9.77492L1.64594 8.76158C1.2326 8.34825 1.2326 7.66824 1.64594 7.25491L2.65926 6.24156C2.8326 6.06823 2.9726 5.72822 2.9726 5.48822V4.05487C2.9726 3.46821 3.4526 2.98822 4.03927 2.98822H5.4726C5.7126 2.98822 6.0526 2.84824 6.22593 2.67491L7.23926 1.66156C7.65259 1.24823 8.3326 1.24823 8.74593 1.66156L9.75928 2.67491C9.93261 2.84824 10.2726 2.98822 10.5126 2.98822H11.9459C12.5326 2.98822 13.0126 3.46821 13.0126 4.05487V5.48822C13.0126 5.72822 13.1526 6.06823 13.3259 6.24156L14.3393 7.25491C14.7526 7.66824 14.7526 8.34825 14.3393 8.76158L13.3259 9.77492C13.1526 9.94826 13.0126 10.2883 13.0126 10.5283V11.9615C13.0126 12.5482 12.5326 13.0283 11.9459 13.0283H10.5126C10.2726 13.0283 9.93261 13.1682 9.75928 13.3416L8.74593 14.3549C8.3326 14.7683 7.65259 14.7683 7.23926 14.3549L6.22593 13.3416C6.0526 13.1682 5.7126 13.0283 5.4726 13.0283H4.03927C3.4526 13.0283 2.9726 12.5482 2.9726 11.9615V10.5283C2.9726 10.2816 2.8326 9.94159 2.65926 9.77492Z"
        stroke="#039855"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 10L10 6"
        stroke="#039855"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.66292 9.66536H9.66891"
        stroke="#039855"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.32967 6.33333H6.33566"
        stroke="#039855"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const LocIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 10 12">
      <path d="M9.31005 4.225C8.78505 1.915 6.77005 0.875 5.00005 0.875C5.00005 0.875 5.00005 0.875 4.99505 0.875C3.23005 0.875 1.21005 1.91 0.685048 4.22C0.100048 6.8 1.68005 8.985 3.11005 10.36C3.64005 10.87 4.32005 11.125 5.00005 11.125C5.68005 11.125 6.36005 10.87 6.88505 10.36C8.31505 8.985 9.89505 6.805 9.31005 4.225ZM5.00005 6.73C4.13005 6.73 3.42505 6.025 3.42505 5.155C3.42505 4.285 4.13005 3.58 5.00005 3.58C5.87005 3.58 6.57505 4.285 6.57505 5.155C6.57505 6.025 5.87005 6.73 5.00005 6.73Z" />
    </SvgIcon>
  );
};

export const WhatsAppIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 16 16">
      <g clipPath="url(#clip0_5974_279360)">
        <path
          d="M13.7351 2.32513C12.2236 0.826621 10.2138 0.000914274 8.07246 0C3.65991 0 0.068975 3.5565 0.0672084 7.92794C0.0666943 9.32529 0.43522 10.6893 1.13569 11.8917L0 16L4.24368 14.8976C5.41289 15.5293 6.72935 15.8622 8.06902 15.8627H8.07242H8.07246C12.4843 15.8627 16.0758 12.3056 16.0776 7.93437C16.0784 5.81576 15.2464 3.82374 13.7351 2.32513ZM8.07246 14.5237H8.06986C6.87575 14.523 5.70475 14.2054 4.68336 13.605L4.44029 13.4622L1.92201 14.1163L2.59435 11.6847L2.43598 11.4354C1.7699 10.3861 1.41826 9.17355 1.41876 7.92845C1.42022 4.29505 4.40487 1.33911 8.07498 1.33911C9.85224 1.33984 11.5227 2.02617 12.779 3.27169C14.0352 4.51719 14.7265 6.17292 14.726 7.93381C14.7244 11.5673 11.7397 14.5237 8.07246 14.5237Z"
          fill="#E0E0E0"
        />
        <path
          d="M0.370117 15.5461L1.45393 11.6255C0.785285 10.478 0.433661 9.17622 0.434083 7.84296C0.435836 3.67128 3.86277 0.277344 8.07339 0.277344C10.117 0.278258 12.0351 1.06621 13.4772 2.4963C14.9196 3.92638 15.7135 5.82727 15.7127 7.84888C15.7109 12.0207 12.2838 15.4149 8.07369 15.4149C8.07339 15.4149 8.0739 15.4149 8.07369 15.4149H8.07029C6.79182 15.4145 5.53559 15.0965 4.41987 14.4941L0.370117 15.5461Z"
          fill="url(#paint0_linear_5974_279360)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.0974 4.56182C5.9493 4.23559 5.79337 4.22906 5.65246 4.22335C5.53721 4.21845 5.40528 4.21875 5.27355 4.21875C5.14172 4.21875 4.92749 4.26784 4.74632 4.46386C4.56505 4.65988 4.0542 5.13375 4.0542 6.09751C4.0542 7.06137 4.7628 7.99269 4.86157 8.1235C4.96045 8.25411 6.22944 10.2951 8.23917 11.0803C9.90943 11.7328 10.2493 11.603 10.6119 11.5704C10.9744 11.5377 11.7817 11.0966 11.9465 10.6392C12.1112 10.1818 12.1112 9.7898 12.0618 9.70786C12.0124 9.62623 11.8805 9.57725 11.6828 9.47929C11.485 9.38133 10.513 8.90736 10.3317 8.84205C10.1504 8.77675 10.0186 8.7441 9.88678 8.94022C9.75495 9.13614 9.37623 9.57725 9.26087 9.70786C9.14552 9.83877 9.03017 9.85509 8.83242 9.75714C8.63467 9.65888 7.99785 9.45224 7.24239 8.7849C6.6546 8.26572 6.25776 7.6245 6.14241 7.42839C6.02705 7.23247 6.13004 7.12635 6.22923 7.0287C6.31801 6.94094 6.42698 6.80002 6.52586 6.68563C6.62452 6.57125 6.65748 6.48961 6.72339 6.359C6.78931 6.22818 6.75635 6.11381 6.70691 6.01585C6.65748 5.91789 6.27321 4.94915 6.0974 4.56182Z"
          fill="white"
        />
        <path
          d="M13.6702 2.29845C12.1761 0.817139 10.1893 0.000927335 8.07258 0C3.71066 0 0.160957 3.51567 0.159204 7.83693C0.15869 9.21826 0.522984 10.5666 1.21541 11.7552L0.0927734 15.8163L4.28774 14.7265C5.44354 15.351 6.74488 15.6801 8.06918 15.6806H8.07254H8.07258C12.4338 15.6806 15.984 12.1643 15.9859 7.84325C15.9866 5.74901 15.1642 3.77986 13.6702 2.29845ZM8.07258 14.357H8.07001C6.88959 14.3563 5.73203 14.0424 4.72238 13.4488L4.48208 13.3077L1.99271 13.9543L2.65733 11.5506L2.50078 11.3041C1.84234 10.2669 1.49474 9.06825 1.49525 7.83746C1.49669 4.24577 4.44707 1.32376 8.07506 1.32376C9.83194 1.32448 11.4831 2.00294 12.7251 3.23415C13.9669 4.46537 14.6502 6.10207 14.6497 7.84277C14.6482 11.4345 11.6977 14.357 8.07258 14.357Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_5974_279360"
          x1="8.04141"
          y1="15.5461"
          x2="8.04141"
          y2="0.277369"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#20B038" />
          <stop offset="1" stopColor="#60D66A" />
        </linearGradient>
        <clipPath id="clip0_5974_279360">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export const GmailIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 16 16">
      <path
        d="M8.29005 9.55198L1.94505 5.51413C1.61702 5.29719 1.38731 4.96012 1.30538 4.57548C1.22345 4.19084 1.29585 3.7894 1.507 3.45762C1.71814 3.12584 2.05114 2.89026 2.43428 2.80159C2.81743 2.71293 3.22007 2.77828 3.5555 2.98357L8.2105 5.94573L12.3901 3.01998C12.7161 2.799 13.1161 2.71517 13.5034 2.78658C13.8908 2.85799 14.2346 3.07891 14.4604 3.40163C14.6863 3.72434 14.7761 4.12296 14.7106 4.51137C14.645 4.89978 14.4293 5.24682 14.1101 5.47753L8.29005 9.55198Z"
        fill="white"
      />
      <path
        d="M13.75 13.25H11.75V4.25C11.75 3.85218 11.908 3.47064 12.1893 3.18934C12.4706 2.90804 12.8522 2.75 13.25 2.75C13.6478 2.75 14.0294 2.90804 14.3107 3.18934C14.592 3.47064 14.75 3.85218 14.75 4.25L14.75 12.25C14.75 12.5152 14.6446 12.7696 14.4571 12.9571C14.2696 13.1446 14.0152 13.25 13.75 13.25Z"
        fill="white"
      />
      <path
        d="M14.7283 4.03126C14.7239 4.00126 14.7243 3.97061 14.718 3.94066C14.7084 3.89476 14.6906 3.85236 14.6769 3.80806C14.6636 3.75736 14.6476 3.7074 14.629 3.65841C14.619 3.63466 14.6036 3.61381 14.5922 3.59071C14.5611 3.52406 14.5251 3.4598 14.4845 3.39846C14.4645 3.36941 14.4395 3.34466 14.4174 3.31716C14.3795 3.26718 14.3385 3.2196 14.2947 3.17471C14.2614 3.14236 14.2235 3.11531 14.1874 3.08616C14.1489 3.05322 14.1089 3.02223 14.0674 2.99331C14.0277 2.96741 13.9843 2.94746 13.9424 2.92536C13.8982 2.90231 13.8549 2.87721 13.8089 2.85881C13.7644 2.84091 13.717 2.82951 13.6706 2.81586C13.6241 2.80221 13.5779 2.78586 13.5302 2.77701C13.4711 2.76752 13.4115 2.76151 13.3517 2.75901C13.3138 2.75636 13.2762 2.74971 13.2381 2.75001C13.1673 2.75207 13.0968 2.75917 13.0271 2.77126C12.999 2.77546 12.9706 2.77511 12.9427 2.78091C12.8483 2.80974 12.7542 2.83941 12.6604 2.86991C12.6347 2.88091 12.6121 2.89726 12.5872 2.90966C12.3332 3.02814 12.1191 3.21762 11.9706 3.45521C11.822 3.69279 11.7455 3.96831 11.7502 4.24846V7.12946L14.1102 5.47731C14.342 5.32177 14.5237 5.1024 14.6333 4.84575C14.743 4.58909 14.7761 4.30625 14.7283 4.03126Z"
        fill="white"
      />
      <path
        d="M2.75 2.75C3.14782 2.75 3.52936 2.90804 3.81066 3.18934C4.09196 3.47064 4.25 3.85218 4.25 4.25V13.25H2.25C1.98478 13.25 1.73043 13.1446 1.54289 12.9571C1.35536 12.7696 1.25 12.5152 1.25 12.25V4.25C1.25 3.85218 1.40804 3.47064 1.68934 3.18934C1.97064 2.90804 2.35218 2.75 2.75 2.75Z"
        fill="white"
      />
      <path
        d="M1.27174 4.03161C1.27614 4.00161 1.27579 3.97096 1.28204 3.94101C1.29164 3.89511 1.30949 3.85271 1.32319 3.80841C1.33647 3.75772 1.35246 3.70778 1.37109 3.65881C1.38109 3.63506 1.39649 3.61421 1.40789 3.59111C1.43898 3.52443 1.47498 3.46016 1.51559 3.39881C1.53559 3.36976 1.56059 3.34501 1.58269 3.31751C1.6206 3.26753 1.66158 3.21995 1.70539 3.17506C1.73864 3.14271 1.77654 3.11566 1.81274 3.08651C1.85115 3.05356 1.8912 3.02257 1.93274 2.99366C1.97239 2.96776 2.01579 2.94781 2.05774 2.92571C2.10109 2.90119 2.14565 2.87886 2.19124 2.85881C2.23574 2.84091 2.28314 2.82951 2.32954 2.81586C2.37594 2.80221 2.42219 2.78586 2.46989 2.77701C2.52898 2.76752 2.58859 2.76151 2.64839 2.75901C2.68639 2.75636 2.72394 2.74971 2.76204 2.75001C2.83277 2.75207 2.90327 2.75917 2.97299 2.77126C3.00114 2.77546 3.02949 2.77511 3.05749 2.78091C3.10589 2.79324 3.15362 2.80806 3.20049 2.82531C3.24762 2.83784 3.2941 2.85272 3.33974 2.86991C3.36544 2.88091 3.38799 2.89726 3.41299 2.90966C3.4778 2.94011 3.54033 2.9752 3.60009 3.01466C3.80041 3.1522 3.96424 3.33644 4.07743 3.55146C4.19062 3.76648 4.24978 4.00582 4.24979 4.24881V7.12981L1.88979 5.47776C1.65808 5.32218 1.4764 5.10281 1.36671 4.84616C1.25703 4.58952 1.22404 4.3066 1.27174 4.03161Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export const ShareIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 18 20">
      <path
        d="M6.15833 11.2596L11.85 14.5763M11.8417 5.4263L6.15833 8.74297M16.5 4.16797C16.5 5.54868 15.3807 6.66797 14 6.66797C12.6193 6.66797 11.5 5.54868 11.5 4.16797C11.5 2.78726 12.6193 1.66797 14 1.66797C15.3807 1.66797 16.5 2.78726 16.5 4.16797ZM6.5 10.0013C6.5 11.382 5.38071 12.5013 4 12.5013C2.61929 12.5013 1.5 11.382 1.5 10.0013C1.5 8.62059 2.61929 7.5013 4 7.5013C5.38071 7.5013 6.5 8.62059 6.5 10.0013ZM16.5 15.8346C16.5 17.2153 15.3807 18.3346 14 18.3346C12.6193 18.3346 11.5 17.2153 11.5 15.8346C11.5 14.4539 12.6193 13.3346 14 13.3346C15.3807 13.3346 16.5 14.4539 16.5 15.8346Z"
        stroke="#4258BF"
        stroke-width="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const InfoIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 12 12">
      <g clipPath="url(#clip0_5974_279416)">
        <path
          d="M6 8V6M6 4H6.005M11 6C11 8.76142 8.76142 11 6 11C3.23858 11 1 8.76142 1 6C1 3.23858 3.23858 1 6 1C8.76142 1 11 3.23858 11 6Z"
          stroke="#ECFDF3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_5974_279416">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export const GmailIcon1 = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 16 16">
      <path
        d="M8.29005 9.55198L1.94505 5.51413C1.61702 5.29719 1.38731 4.96011 1.30538 4.57548C1.22345 4.19084 1.29585 3.7894 1.507 3.45762C1.71814 3.12584 2.05114 2.89026 2.43428 2.80159C2.81743 2.71293 3.22007 2.77828 3.5555 2.98357L8.2105 5.94573L12.3901 3.01998C12.7161 2.799 13.1161 2.71517 13.5034 2.78658C13.8908 2.85799 14.2346 3.07891 14.4604 3.40163C14.6863 3.72434 14.7761 4.12296 14.7106 4.51137C14.645 4.89978 14.4293 5.24682 14.1101 5.47752L8.29005 9.55198Z"
        fill="#EA4435"
      />
      <path
        d="M13.75 13.25H11.75V4.25C11.75 3.85218 11.908 3.47064 12.1893 3.18934C12.4706 2.90804 12.8522 2.75 13.25 2.75C13.6478 2.75 14.0294 2.90804 14.3107 3.18934C14.592 3.47064 14.75 3.85218 14.75 4.25L14.75 12.25C14.75 12.5152 14.6446 12.7696 14.4571 12.9571C14.2696 13.1446 14.0152 13.25 13.75 13.25Z"
        fill="#00AC47"
      />
      <path
        d="M14.7283 4.03126C14.7239 4.00126 14.7243 3.97061 14.718 3.94066C14.7084 3.89476 14.6906 3.85236 14.6769 3.80806C14.6636 3.75736 14.6476 3.7074 14.629 3.65841C14.619 3.63466 14.6036 3.61381 14.5922 3.59071C14.5611 3.52406 14.5251 3.4598 14.4845 3.39846C14.4645 3.36941 14.4395 3.34466 14.4174 3.31716C14.3795 3.26718 14.3385 3.2196 14.2947 3.17471C14.2614 3.14236 14.2235 3.11531 14.1874 3.08616C14.1489 3.05322 14.1089 3.02223 14.0674 2.99331C14.0277 2.96741 13.9843 2.94746 13.9424 2.92536C13.8982 2.90231 13.8549 2.87721 13.8089 2.85881C13.7644 2.84091 13.717 2.82951 13.6706 2.81586C13.6241 2.80221 13.5779 2.78586 13.5302 2.77701C13.4711 2.76752 13.4115 2.76151 13.3517 2.75901C13.3138 2.75636 13.2762 2.74971 13.2381 2.75001C13.1673 2.75207 13.0968 2.75917 13.0271 2.77126C12.999 2.77546 12.9706 2.77511 12.9427 2.78091C12.8483 2.80974 12.7542 2.83941 12.6604 2.86991C12.6347 2.88091 12.6121 2.89726 12.5872 2.90966C12.3332 3.02814 12.1191 3.21762 11.9706 3.45521C11.822 3.69279 11.7455 3.96831 11.7502 4.24846V7.12946L14.1102 5.47731C14.342 5.32177 14.5237 5.1024 14.6333 4.84575C14.743 4.58909 14.7761 4.30625 14.7283 4.03126Z"
        fill="#FFBA00"
      />
      <path
        d="M2.75 2.75C3.14782 2.75 3.52936 2.90804 3.81066 3.18934C4.09196 3.47064 4.25 3.85218 4.25 4.25V13.25H2.25C1.98478 13.25 1.73043 13.1446 1.54289 12.9571C1.35536 12.7696 1.25 12.5152 1.25 12.25V4.25C1.25 3.85218 1.40804 3.47064 1.68934 3.18934C1.97064 2.90804 2.35218 2.75 2.75 2.75Z"
        fill="#4285F4"
      />
      <path
        d="M1.27174 4.03161C1.27614 4.00161 1.27579 3.97096 1.28204 3.94101C1.29164 3.89511 1.30949 3.85271 1.32319 3.80841C1.33647 3.75772 1.35246 3.70778 1.37109 3.65881C1.38109 3.63506 1.39649 3.61421 1.40789 3.59111C1.43898 3.52443 1.47498 3.46016 1.51559 3.39881C1.53559 3.36976 1.56059 3.34501 1.58269 3.31751C1.6206 3.26753 1.66158 3.21995 1.70539 3.17506C1.73864 3.14271 1.77654 3.11566 1.81274 3.08651C1.85115 3.05356 1.8912 3.02257 1.93274 2.99366C1.97239 2.96776 2.01579 2.94781 2.05774 2.92571C2.10109 2.90119 2.14565 2.87886 2.19124 2.85881C2.23574 2.84091 2.28314 2.82951 2.32954 2.81586C2.37594 2.80221 2.42219 2.78586 2.46989 2.77701C2.52898 2.76752 2.58859 2.76151 2.64839 2.75901C2.68639 2.75636 2.72394 2.74971 2.76204 2.75001C2.83277 2.75207 2.90327 2.75917 2.97299 2.77126C3.00114 2.77546 3.02949 2.77511 3.05749 2.78091C3.10589 2.79324 3.15362 2.80806 3.20049 2.82531C3.24762 2.83784 3.2941 2.85272 3.33974 2.86991C3.36544 2.88091 3.38799 2.89726 3.41299 2.90966C3.4778 2.94011 3.54033 2.9752 3.60009 3.01466C3.80041 3.1522 3.96423 3.33644 4.07743 3.55146C4.19062 3.76648 4.24978 4.00582 4.24979 4.24881V7.12981L1.88979 5.47776C1.65808 5.32218 1.4764 5.10281 1.36671 4.84616C1.25703 4.58952 1.22404 4.3066 1.27174 4.03161Z"
        fill="#C52528"
      />
    </SvgIcon>
  );
};

export const ErrorIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 17 16">
      <path
        d="M15.3397 10.612L11.073 2.93203C10.4997 1.8987 9.70633 1.33203 8.83299 1.33203C7.95966 1.33203 7.16633 1.8987 6.59299 2.93203L2.32633 10.612C1.78633 11.592 1.72633 12.532 2.15966 13.272C2.59299 14.012 3.44633 14.4187 4.56633 14.4187H13.0997C14.2197 14.4187 15.073 14.012 15.5063 13.272C15.9397 12.532 15.8797 11.5854 15.3397 10.612ZM8.33299 5.9987C8.33299 5.72536 8.55966 5.4987 8.83299 5.4987C9.10633 5.4987 9.33299 5.72536 9.33299 5.9987V9.33203C9.33299 9.60536 9.10633 9.83203 8.83299 9.83203C8.55966 9.83203 8.33299 9.60536 8.33299 9.33203V5.9987ZM9.30633 11.8054C9.27299 11.832 9.23966 11.8587 9.20633 11.8854C9.16633 11.912 9.12633 11.932 9.08633 11.9454C9.04633 11.9654 9.00633 11.9787 8.95966 11.9854C8.91966 11.992 8.87299 11.9987 8.83299 11.9987C8.79299 11.9987 8.74633 11.992 8.69966 11.9854C8.65966 11.9787 8.61966 11.9654 8.57966 11.9454C8.53966 11.932 8.49966 11.912 8.45966 11.8854C8.42633 11.8587 8.39299 11.832 8.35966 11.8054C8.23966 11.6787 8.16633 11.5054 8.16633 11.332C8.16633 11.1587 8.23966 10.9854 8.35966 10.8587C8.39299 10.832 8.42633 10.8054 8.45966 10.7787C8.49966 10.752 8.53966 10.732 8.57966 10.7187C8.61966 10.6987 8.65966 10.6854 8.69966 10.6787C8.78633 10.6587 8.87966 10.6587 8.95966 10.6787C9.00633 10.6854 9.04633 10.6987 9.08633 10.7187C9.12633 10.732 9.16633 10.752 9.20633 10.7787C9.23966 10.8054 9.27299 10.832 9.30633 10.8587C9.42633 10.9854 9.49966 11.1587 9.49966 11.332C9.49966 11.5054 9.42633 11.6787 9.30633 11.8054Z"
        fill={props.color ? props.color : "#F04438"}
      />
    </SvgIcon>
  );
};

export const SuccessIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 17 16">
      <path
        d="M8.66667 1.33203C4.99333 1.33203 2 4.32536 2 7.9987C2 11.672 4.99333 14.6654 8.66667 14.6654C12.34 14.6654 15.3333 11.672 15.3333 7.9987C15.3333 4.32536 12.34 1.33203 8.66667 1.33203ZM11.8533 6.46536L8.07333 10.2454C7.98 10.3387 7.85333 10.392 7.72 10.392C7.58667 10.392 7.46 10.3387 7.36667 10.2454L5.48 8.3587C5.28667 8.16536 5.28667 7.84536 5.48 7.65203C5.67333 7.4587 5.99333 7.4587 6.18667 7.65203L7.72 9.18536L11.1467 5.7587C11.34 5.56536 11.66 5.56536 11.8533 5.7587C12.0467 5.95203 12.0467 6.26536 11.8533 6.46536Z"
        fill={props.fill ? props.fill : "#12B76A"}
      />
    </SvgIcon>
  );
};

export const TransferIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 16 16">
      <path
        d="M2.97109 7.21598L3.93375 4.64888C4.08012 4.25857 4.45324 4 4.87008 4H11.0396C11.4565 4 11.8296 4.25857 11.976 4.64888L12.9386 7.21598C13.0228 7.44053 13.066 7.6784 13.066 7.91822V12V13.2448C13.066 13.2937 13.0263 13.3333 12.9774 13.3333C12.9285 13.3333 12.8889 13.2937 12.8889 13.2448V12H3.11111V13.1997C3.11111 13.2735 3.05126 13.3333 2.97743 13.3333C2.9036 13.3333 2.84375 13.2735 2.84375 13.1997V12V7.91822C2.84375 7.6784 2.88688 7.44053 2.97109 7.21598Z"
        fill="white"
      />
      <path
        d="M13.066 12V7.91822C13.066 7.6784 13.0228 7.44053 12.9386 7.21598L11.976 4.64888C11.8296 4.25857 11.4565 4 11.0396 4H4.87008C4.45324 4 4.08012 4.25857 3.93375 4.64888L2.97109 7.21598C2.88688 7.44053 2.84375 7.6784 2.84375 7.91822V12M13.066 12V13.2448C13.066 13.2937 13.0263 13.3333 12.9774 13.3333V13.3333C12.9285 13.3333 12.8889 13.2937 12.8889 13.2448V12M13.066 12H12.8889M2.84375 12V13.1997C2.84375 13.2735 2.9036 13.3333 2.97743 13.3333V13.3333C3.05126 13.3333 3.11111 13.2735 3.11111 13.1997V12M2.84375 12H3.11111M3.11111 12H12.8889"
        stroke="#21314D"
        strokeLinecap="round"
      />
      <path d="M2.6665 7.55566H12.8887" stroke="#21314D" />
      <circle cx="5.15545" cy="9.86687" r="0.711111" fill="#21314D" />
      <circle cx="10.4889" cy="9.86687" r="0.711111" fill="#21314D" />
    </SvgIcon>
  );
};

export const TtdIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 16 16">
      <path
        d="M11.3298 2.6665H4.66309C2.10976 2.6665 1.39643 3.27984 1.33643 5.6665C2.62309 5.6665 3.66309 6.71317 3.66309 7.99984C3.66309 9.2865 2.62309 10.3265 1.33643 10.3332C1.39643 12.7198 2.10976 13.3332 4.66309 13.3332H11.3298C13.9964 13.3332 14.6631 12.6665 14.6631 9.99984V5.99984C14.6631 3.33317 13.9964 2.6665 11.3298 2.6665Z"
        stroke="#21314D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.99561 2.6665V4.99984"
        stroke="#21314D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.99561 11V13.3333"
        stroke="#21314D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0165 6.21994L10.4298 7.05327C10.4698 7.13327 10.5498 7.19327 10.6365 7.20661L11.5565 7.33994C11.7832 7.37327 11.8765 7.65327 11.7098 7.81327L11.0432 8.45994C10.9765 8.51994 10.9498 8.61327 10.9632 8.70661L11.1232 9.61994C11.1632 9.84661 10.9232 10.0199 10.7232 9.91327L9.90318 9.47994C9.82318 9.43994 9.72318 9.43994 9.64318 9.47994L8.82318 9.91327C8.61651 10.0199 8.38318 9.84661 8.42318 9.61994L8.58318 8.70661C8.59651 8.61327 8.56985 8.52661 8.50318 8.45994L7.84318 7.81327C7.67652 7.65327 7.76985 7.37327 7.99651 7.33994L8.91651 7.20661C9.00985 7.19327 9.08318 7.13994 9.12318 7.05327L9.52985 6.21994C9.62318 6.01327 9.91651 6.01327 10.0165 6.21994Z"
        stroke="#21314D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const FlightIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 16 16">
      <g clipPath="url(#clip0_7192_107661)">
        <path
          d="M13.9999 9.72016C13.9999 9.48016 13.8733 9.26016 13.6733 9.12683L8.66659 6.00016V2.3335C8.66659 1.78016 8.21992 1.3335 7.66659 1.3335C7.11325 1.3335 6.66659 1.78016 6.66659 2.3335V6.00016L1.65992 9.12683C1.45992 9.2535 1.33325 9.48016 1.33325 9.72016C1.33325 10.1868 1.78659 10.5268 2.23992 10.3868L6.66659 9.00016V12.6668L5.46659 13.5668C5.37992 13.6268 5.33325 13.7268 5.33325 13.8335V14.2268C5.33325 14.4468 5.54659 14.6068 5.75992 14.5468L7.66659 14.0002L9.57325 14.5468C9.78659 14.6068 9.99992 14.4468 9.99992 14.2268V13.8335C9.99992 13.7268 9.95325 13.6268 9.86659 13.5668L8.66659 12.6668V9.00016L13.0933 10.3868C13.5466 10.5268 13.9999 10.1868 13.9999 9.72016Z"
          stroke="#21314D"
        />
      </g>
      <defs>
        <clipPath id="clip0_7192_107661">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export const StayIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M2 3V12.5" stroke="#21314D" strokeLinecap="round" />
      <path d="M15 9.5L1.82642 9.5" stroke="#21314D" />
      <path
        d="M8.5 9.5L8.5 4.7C8.5 4.58954 8.58954 4.5 8.7 4.5L14 4.5C14.5523 4.5 15 4.94772 15 5.5L15 9L15 12.5"
        stroke="#21314D"
        strokeLinecap="round"
      />
      <circle cx="5.19995" cy="5.7998" r="1.5" stroke="#21314D" />
    </svg>
  );
};

export const TtdColorIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 36 36">
      <path
        opacity="0.4"
        d="M32.9999 13.815V22.185C32.9999 28.335 31.1249 30.21 24.9749 30.21H14.8649V25.68C14.8649 25.11 14.3849 24.63 13.8149 24.63V11.37C14.3849 11.37 14.8649 10.89 14.8649 10.32V5.79004H24.9749C31.1249 5.79004 32.9999 7.66504 32.9999 13.815Z"
        fill="#8CA0FF"
      />
      <path
        d="M27.7048 17.8501C27.9598 17.6101 28.0498 17.2351 27.9448 16.9051C27.8398 16.5601 27.5548 16.3201 27.1948 16.2751L25.2748 15.9901C25.1998 15.9751 25.1398 15.9301 25.1098 15.8701L24.2548 14.1301C24.1048 13.8151 23.7748 13.6201 23.4298 13.6201C23.0698 13.6201 22.7548 13.8151 22.5898 14.1301L21.7348 15.8701C21.7048 15.9451 21.6298 15.9901 21.5548 15.9901L19.6348 16.2751C19.2898 16.3201 18.9898 16.5751 18.8848 16.9051C18.7798 17.2501 18.8698 17.6101 19.1248 17.8501L20.5198 19.2001C20.5798 19.2451 20.5948 19.3351 20.5798 19.4101L20.2498 21.3151C20.1898 21.6601 20.3248 22.0201 20.6248 22.2151C20.7898 22.3351 20.9698 22.3951 21.1648 22.3951C21.3148 22.3951 21.4648 22.3651 21.5998 22.2901L23.3248 21.3901C23.3848 21.3601 23.4748 21.3601 23.5348 21.3901L25.2598 22.2901C25.5748 22.4551 25.9498 22.4251 26.2348 22.2151C26.5198 22.0051 26.6698 21.6601 26.6098 21.3001L26.2798 19.3951C26.2648 19.3201 26.2948 19.2451 26.3398 19.1851L27.7048 17.8501Z"
        fill="#8CA0FF"
      />
      <path
        d="M13.8149 11.37V24.63C13.2449 24.63 12.7649 25.11 12.7649 25.68V30.21H11.0249C5.09993 30.21 3.14993 28.44 3.01493 22.92C2.99993 22.635 3.11993 22.365 3.31493 22.17C3.50993 21.96 3.79493 21.855 4.06493 21.855C6.16493 21.855 7.88993 20.13 7.88993 18.015C7.88993 15.9 6.16493 14.16 4.06493 14.16C3.76493 14.16 3.50993 14.055 3.31493 13.845C3.11993 13.65 2.99993 13.365 3.01493 13.095C3.14993 7.56004 5.09993 5.79004 11.0249 5.79004H12.7649V10.32C12.7649 10.905 13.2449 11.37 13.8149 11.37Z"
        fill="#8CA0FF"
      />
    </SvgIcon>
  );
};

export const LocationIcon = (props) => {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99998 9.45021C6.57998 9.45021 5.41998 8.29687 5.41998 6.87021C5.41998 5.44354 6.57998 4.29688 7.99998 4.29688C9.41998 4.29688 10.58 5.45021 10.58 6.87688C10.58 8.30354 9.41998 9.45021 7.99998 9.45021ZM7.99998 5.29687C7.13332 5.29687 6.41998 6.00354 6.41998 6.87688C6.41998 7.75021 7.12665 8.45687 7.99998 8.45687C8.87332 8.45687 9.57998 7.75021 9.57998 6.87688C9.57998 6.00354 8.86665 5.29687 7.99998 5.29687Z"
        fill="#122441"
      />
      <path
        d="M7.99988 1.33594H8.00671C8.40317 1.33594 8.80784 1.37618 9.20984 1.45703C8.79471 1.37446 8.38565 1.33594 7.99988 1.33594ZM7.99988 1.33594C7.74524 1.33594 7.48058 1.35261 7.21082 1.3877C7.40187 1.36264 7.5927 1.34675 7.7821 1.33984L7.99988 1.33594ZM13.7489 7.30859C13.6757 9.72907 12.2571 11.8151 10.7694 13.3418L10.4061 13.7021C9.72806 14.3504 8.86009 14.6758 7.99988 14.6758C7.19298 14.6758 6.37897 14.3899 5.72156 13.8193L5.59265 13.7012C3.71651 11.8947 1.78137 9.16688 2.35144 5.97754L2.41394 5.66699C2.50028 5.28663 2.61819 4.93239 2.76257 4.60449C2.62242 4.92921 2.50572 5.28167 2.41882 5.66406C1.63563 9.07966 3.7901 11.9612 5.60046 13.6973V13.6963C6.94744 14.9957 9.05932 14.995 10.4061 13.6953L10.4071 13.6963C11.9131 12.2467 13.6604 9.99883 13.7489 7.30859ZM9.24402 1.46387C9.3616 1.48821 9.4788 1.51642 9.59558 1.54785C9.47807 1.51672 9.36102 1.48781 9.24402 1.46387ZM6.44226 1.53906C6.53445 1.51479 6.62691 1.49253 6.7196 1.47266C6.62722 1.49216 6.53495 1.51507 6.44226 1.53906ZM6.83191 1.4502C6.94706 1.42774 7.06232 1.40834 7.17761 1.39258C7.06306 1.40809 6.94785 1.4279 6.83191 1.4502ZM13.7518 6.94531C13.7543 7.03824 13.7534 7.13067 13.7518 7.22266C13.7536 7.1307 13.754 7.03828 13.7518 6.94531Z"
        fill="#122441"
        stroke="#122441"
      />
    </SvgIcon>
  );
};

export const CalendarIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 16 16">
      <path
        d="M5.33334 3.83594C5.06001 3.83594 4.83334 3.60927 4.83334 3.33594V1.33594C4.83334 1.0626 5.06001 0.835938 5.33334 0.835938C5.60668 0.835938 5.83334 1.0626 5.83334 1.33594V3.33594C5.83334 3.60927 5.60668 3.83594 5.33334 3.83594Z"
        fill="#122441"
      />
      <path
        d="M10.6667 3.83594C10.3933 3.83594 10.1667 3.60927 10.1667 3.33594V1.33594C10.1667 1.0626 10.3933 0.835938 10.6667 0.835938C10.94 0.835938 11.1667 1.0626 11.1667 1.33594V3.33594C11.1667 3.60927 10.94 3.83594 10.6667 3.83594Z"
        fill="#122441"
      />
      <path
        d="M13.6667 6.5625H2.33334C2.06001 6.5625 1.83334 6.33583 1.83334 6.0625C1.83334 5.78917 2.06001 5.5625 2.33334 5.5625H13.6667C13.94 5.5625 14.1667 5.78917 14.1667 6.0625C14.1667 6.33583 13.94 6.5625 13.6667 6.5625Z"
        fill="#122441"
      />
      <path
        d="M10.6667 15.1693H5.33333C2.9 15.1693 1.5 13.7693 1.5 11.3359V5.66927C1.5 3.23594 2.9 1.83594 5.33333 1.83594H10.6667C13.1 1.83594 14.5 3.23594 14.5 5.66927V11.3359C14.5 13.7693 13.1 15.1693 10.6667 15.1693ZM5.33333 2.83594C3.42667 2.83594 2.5 3.7626 2.5 5.66927V11.3359C2.5 13.2426 3.42667 14.1693 5.33333 14.1693H10.6667C12.5733 14.1693 13.5 13.2426 13.5 11.3359V5.66927C13.5 3.7626 12.5733 2.83594 10.6667 2.83594H5.33333Z"
        fill="#122441"
      />
      <path
        d="M5.66667 9.66928C5.58 9.66928 5.49333 9.64929 5.41333 9.61595C5.33333 9.58262 5.26001 9.53594 5.19334 9.47594C5.13334 9.40927 5.08666 9.33595 5.05332 9.25595C5.01999 9.17595 5 9.08928 5 9.00261C5 8.82928 5.07334 8.65595 5.19334 8.52928C5.26001 8.46928 5.33333 8.4226 5.41333 8.38927C5.53333 8.33594 5.66667 8.3226 5.80001 8.34927C5.84001 8.35594 5.88 8.36927 5.92 8.38927C5.96 8.4026 6 8.42262 6.04 8.44929C6.07333 8.47595 6.10666 8.50262 6.13999 8.52928C6.16666 8.56262 6.19999 8.59595 6.21999 8.62928C6.24666 8.66928 6.26668 8.70928 6.28001 8.74928C6.30001 8.78928 6.31334 8.82927 6.32001 8.86927C6.32667 8.91594 6.33333 8.95595 6.33333 9.00261C6.33333 9.17595 6.25999 9.34927 6.13999 9.47594C6.01333 9.59594 5.84 9.66928 5.66667 9.66928Z"
        fill="#122441"
      />
      <path
        d="M8.00001 9.66854C7.82668 9.66854 7.65335 9.5952 7.52668 9.4752C7.50002 9.44186 7.47335 9.40853 7.44669 9.3752C7.42002 9.3352 7.4 9.29521 7.38667 9.25521C7.36667 9.21521 7.35334 9.17521 7.34667 9.13521C7.34 9.08854 7.33334 9.04854 7.33334 9.00187C7.33334 8.9152 7.35333 8.82853 7.38667 8.74853C7.42 8.66853 7.46668 8.59521 7.52668 8.52854C7.71335 8.34187 8.01335 8.28186 8.25335 8.38853C8.34001 8.42186 8.40667 8.46854 8.47334 8.52854C8.59334 8.65521 8.66668 8.82854 8.66668 9.00187C8.66668 9.04854 8.66002 9.08854 8.65335 9.13521C8.64668 9.17521 8.63335 9.21521 8.61335 9.25521C8.60002 9.29521 8.58 9.3352 8.55333 9.3752C8.52667 9.40853 8.5 9.44186 8.47334 9.4752C8.40667 9.5352 8.34001 9.58188 8.25335 9.61521C8.17335 9.64854 8.08668 9.66854 8.00001 9.66854Z"
        fill="#122441"
      />
      <path
        d="M5.66667 11.9967C5.58 11.9967 5.49333 11.9767 5.41333 11.9433C5.33333 11.91 5.26001 11.8633 5.19334 11.8033C5.13334 11.7367 5.08666 11.67 5.05332 11.5833C5.01999 11.5033 5 11.4167 5 11.33C5 11.1567 5.07334 10.9833 5.19334 10.8567C5.26001 10.7967 5.33333 10.75 5.41333 10.7167C5.66 10.61 5.95333 10.67 6.13999 10.8567C6.16666 10.89 6.19999 10.9233 6.21999 10.9567C6.24666 10.9967 6.26668 11.0367 6.28001 11.0767C6.30001 11.1167 6.31334 11.1567 6.32001 11.2033C6.32667 11.2433 6.33333 11.29 6.33333 11.33C6.33333 11.5033 6.25999 11.6767 6.13999 11.8033C6.01333 11.9233 5.84 11.9967 5.66667 11.9967Z"
        fill="#122441"
      />
    </SvgIcon>
  );
};

export const RecommendationIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 17 16">
      <g clip-path="url(#clip0_8827_202695)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.62891 16H8.37109C8.37109 13.8971 7.58464 12.0586 6.01302 10.487C4.44141 8.91537 2.60417 8.12891 0.5 8.12891V7.87109C2.60417 7.87109 4.44141 7.08464 6.01302 5.50912C7.58464 3.93359 8.37109 2.09635 8.37109 0H8.62891C8.62891 2.10286 9.41537 3.94141 10.987 5.51302C12.5586 7.08464 14.3958 7.87109 16.5 7.87109V8.12891C14.3971 8.12891 12.5586 8.91537 10.987 10.487C9.41537 12.0586 8.62891 13.8958 8.62891 16Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_8827_202695">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export const StayStarIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 22 20">
      <path
        d="M15.825 4.33906L16.9999 6.68906C17.1583 7.01406 17.5833 7.32239 17.9416 7.38905L20.0666 7.73905C21.425 7.96405 21.7416 8.94739 20.7666 9.93072L19.1083 11.5891C18.8333 11.8641 18.675 12.4057 18.7666 12.7974L19.2416 14.8474C19.6166 16.4641 18.75 17.0974 17.325 16.2474L15.3333 15.0641C14.9749 14.8474 14.375 14.8474 14.0166 15.0641L12.0249 16.2474C10.5999 17.0891 9.73329 16.4641 10.1083 14.8474L10.5833 12.7974C10.675 12.4141 10.5166 11.8724 10.2416 11.5891L8.5833 9.93072C7.6083 8.95572 7.92497 7.97238 9.2833 7.73905L11.4083 7.38905C11.7666 7.33072 12.1916 7.01406 12.35 6.68906L13.525 4.33906C14.15 3.06406 15.1833 3.06406 15.825 4.33906Z"
        fill="#D1D9FF"
      />
      <path
        d="M12.825 4.33906L13.9999 6.68906C14.1583 7.01406 14.5833 7.32239 14.9416 7.38905L17.0666 7.73905C18.425 7.96405 18.7416 8.94739 17.7666 9.93072L16.1083 11.5891C15.8333 11.8641 15.675 12.4057 15.7666 12.7974L16.2416 14.8474C16.6166 16.4641 15.75 17.0974 14.325 16.2474L12.3333 15.0641C11.9749 14.8474 11.375 14.8474 11.0166 15.0641L9.02495 16.2474C7.59995 17.0891 6.73329 16.4641 7.10829 14.8474L7.5833 12.7974C7.67496 12.4141 7.51663 11.8724 7.24163 11.5891L5.5833 9.93072C4.6083 8.95572 4.92497 7.97238 6.2833 7.73905L8.40829 7.38905C8.76662 7.33072 9.19163 7.01406 9.34996 6.68906L10.525 4.33906C11.15 3.06406 12.1833 3.06406 12.825 4.33906Z"
        fill="white"
        stroke="#4258BF"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.6665 4.16406H1.6665"
        stroke="#4258BF"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.1665 15.8359H1.6665"
        stroke="#4258BF"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.49984 10H1.6665"
        stroke="#4258BF"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </SvgIcon>
  );
};

export const AmenityIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 20 21">
      <path
        d="M8.63867 1.68133V20.5031H19.4387V1.68133C19.4387 1.14108 19.0007 0.703125 18.4605 0.703125H9.61687C9.07663 0.703125 8.63867 1.14108 8.63867 1.68133Z"
        fill="#D1D9FF"
      />
      <path
        d="M6.58789 3.93133V20.1939H17.3074V3.93133C17.3074 3.39108 16.8694 2.95312 16.3292 2.95312H7.56609C7.02585 2.95312 6.58789 3.39108 6.58789 3.93133Z"
        fill="white"
        stroke="#4258BF"
        stroke-width="1.35"
      />
      <path
        d="M10.1328 20.0276V16.8485C10.1328 16.5784 10.3518 16.3594 10.6219 16.3594H13.312C13.5821 16.3594 13.8011 16.5784 13.8011 16.8485V20.0276"
        stroke="#4258BF"
        stroke-width="1.35"
        stroke-linecap="round"
      />
      <path
        d="M1.11921 11.9543L6.58779 9.59375V20.1909H1.24843C1.06835 20.1909 0.922363 20.045 0.922363 19.8649V12.2537C0.922363 12.1235 0.999735 12.0059 1.11921 11.9543Z"
        stroke="#4258BF"
        stroke-width="1.35"
      />
      <path
        d="M9.60205 5.67969H10.3062"
        stroke="#6879CC"
        stroke-width="1.35"
        stroke-linecap="round"
      />
      <path
        d="M3.23877 13.75H3.94289"
        stroke="#6879CC"
        stroke-width="1.35"
        stroke-linecap="round"
      />
      <path
        d="M3.23877 16.8984H3.94289"
        stroke="#6879CC"
        stroke-width="1.35"
        stroke-linecap="round"
      />
      <path
        d="M9.60205 9.09375H10.3062"
        stroke="#6879CC"
        stroke-width="1.35"
        stroke-linecap="round"
      />
      <path
        d="M9.60205 12.6953H10.3062"
        stroke="#6879CC"
        stroke-width="1.35"
        stroke-linecap="round"
      />
      <path
        d="M13.4331 5.67969H14.1372"
        stroke="#6879CC"
        stroke-width="1.35"
        stroke-linecap="round"
      />
      <path
        d="M13.4326 9.09375H14.1367"
        stroke="#4258BF"
        stroke-width="1.35"
        stroke-linecap="round"
      />
      <path
        d="M13.4326 12.6953H14.1367"
        stroke="#4258BF"
        stroke-width="1.35"
        stroke-linecap="round"
      />
    </SvgIcon>
  );
};

export const PolicyIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 21 19">
      <path
        d="M12.0671 17.6771C16.5774 17.6771 20.2337 14.0207 20.2337 9.51042C20.2337 5.00009 16.5774 1.34375 12.0671 1.34375C7.55673 1.34375 3.90039 5.00009 3.90039 9.51042C3.90039 14.0207 7.55673 17.6771 12.0671 17.6771Z"
        fill="#D1D9FF"
      />
      <path
        d="M9.26628 17.6771C13.7766 17.6771 17.4329 14.0207 17.4329 9.51042C17.4329 5.00009 13.7766 1.34375 9.26628 1.34375C4.75595 1.34375 1.09961 5.00009 1.09961 9.51042C1.09961 14.0207 4.75595 17.6771 9.26628 17.6771Z"
        fill="white"
        stroke="#4258BF"
        stroke-width="1.4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.54883 11.4116C6.54883 12.4651 7.35733 13.3145 8.36183 13.3145H10.4117C11.2855 13.3145 11.996 12.5713 11.996 11.6566C11.996 10.6603 11.5632 10.3091 10.918 10.0805L7.62683 8.93712C6.98166 8.70846 6.54883 8.35729 6.54883 7.36096C6.54883 6.44629 7.25933 5.70312 8.13316 5.70312H10.183C11.1875 5.70312 11.996 6.55246 11.996 7.60596"
        stroke="#4258BF"
        stroke-width="1.4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.26758 4.60938V14.4094"
        stroke="#4258BF"
        stroke-width="1.4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </SvgIcon>
  );
};

export const FilterIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 16 17">
      <path
        d="M3.60091 1.71484H12.4009C13.1342 1.71484 13.7342 2.31484 13.7342 3.04818V4.51484C13.7342 5.04818 13.4009 5.71484 13.0676 6.04818L10.2009 8.58151C9.80091 8.91484 9.53424 9.58151 9.53424 10.1148V12.9815C9.53424 13.3815 9.26758 13.9148 8.93424 14.1148L8.00091 14.7148C7.13425 15.2482 5.93424 14.6482 5.93424 13.5815V10.0482C5.93424 9.58151 5.66758 8.98151 5.40091 8.64818L2.86758 5.98151C2.53424 5.64818 2.26758 5.04818 2.26758 4.64818V3.11484C2.26758 2.31484 2.86758 1.71484 3.60091 1.71484Z"
        stroke="#ECEEF9"
        fill="transparent"
        stroke-width="1.2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </SvgIcon>
  );
};

export const EditIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 12 12">
      <g clip-path="url(#clip0_8786_207089)">
        <path
          d="M5.5 1.99816H2C1.73478 1.99816 1.48043 2.10352 1.29289 2.29105C1.10536 2.47859 1 2.73294 1 2.99816V9.99816C1 10.2634 1.10536 10.5177 1.29289 10.7053C1.48043 10.8928 1.73478 10.9982 2 10.9982H9C9.26522 10.9982 9.51957 10.8928 9.70711 10.7053C9.89464 10.5177 10 10.2634 10 9.99816V6.49816M9.25 1.24816C9.44891 1.04925 9.7187 0.9375 10 0.9375C10.2813 0.9375 10.5511 1.04925 10.75 1.24816C10.9489 1.44707 11.0607 1.71686 11.0607 1.99816C11.0607 2.27946 10.9489 2.54925 10.75 2.74816L6 7.49816L4 7.99816L4.5 5.99816L9.25 1.24816Z"
          stroke="#4258BF"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_8786_207089">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};
